import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { API, pesanGalat } from "../lib/api";
import { useAuth } from "../auth";

const AKUN = [
  ["Admin IT", "syaefulaxl@gmail.com", "Admin#PAMIT2026"],
  ["Pemilik Akses", "pemilik@pamit.demo", "Pemilik#2026"],
  ["HR", "hr@pamit.demo", "HR#PAMIT2026"],
  ["Manajer", "manajer@pamit.demo", "Manajer#2026"],
];

const BERANDA = { admin: "/buku", pemilik: "/buku", hr: "/pamit", manajer: "/dampak" };

export default function Login() {
  const [email, setEmail] = useState("");
  const [sandi, setSandi] = useState("");
  const [galat, setGalat] = useState(null);
  const [muat, setMuat] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();

  const kirim = async (e) => {
    e.preventDefault();
    setMuat(true);
    setGalat(null);
    try {
      const r = await API.post("/auth/login", { email, password: sandi });
      localStorage.setItem("pamit_token", r.data.token);
      setUser(r.data.pengguna);
      nav(BERANDA[r.data.pengguna.peran] || "/buku");
    } catch (err) {
      setGalat(pesanGalat(err));
    } finally {
      setMuat(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="kaca border-b">
        <div className="max-w-[1000px] mx-auto px-4 md:px-8 h-14 flex items-center justify-between">
          <Link to="/" data-testid="tautan-beranda" className="flex items-center gap-2">
            <ShieldCheck size={18} className="text-primary" aria-hidden="true" />
            <span className="font-heading font-bold text-lg">PAM-IT</span>
          </Link>
          <Link to="/verifikasi" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
            Cek surat
          </Link>
        </div>
      </header>
      <main className="halaman-kerja flex-1 flex items-start justify-center px-4 py-16">
        <div className="panel rounded w-full max-w-md p-7">
          <p className="label-kecil">Ruang kerja internal</p>
          <h1 className="mt-4 text-4xl font-bold">Masuk</h1>
          <p className="mt-2 text-sm text-muted-foreground">Buat Admin IT, Pemilik Akses, HR, dan Manajer.</p>
          <form onSubmit={kirim} className="mt-7 space-y-4">
            <div>
              <label htmlFor="email" className="label-kecil">Email</label>
              <input id="email" data-testid="input-email" type="email" required value={email}
                onChange={(e) => setEmail(e.target.value)} className="mt-1.5 w-full border rounded px-3 py-2.5 text-sm" />
            </div>
            <div>
              <label htmlFor="sandi" className="label-kecil">Kata sandi</label>
              <input id="sandi" data-testid="input-kata-sandi" type="password" required value={sandi}
                onChange={(e) => setSandi(e.target.value)} className="mt-1.5 w-full border rounded px-3 py-2.5 text-sm" />
            </div>
            {galat && <p data-testid="galat-masuk" className="text-sm text-destructive">{galat}</p>}
            <button data-testid="btn-masuk" disabled={muat} className="tombol-utama w-full px-4 py-2.5 rounded text-sm disabled:opacity-50">
              {muat ? "Sebentar…" : "Masuk"}
            </button>
          </form>
          <div className="mt-7 border-t pt-5">
            <p className="text-sm text-muted-foreground">
              Perusahaan Anda belum punya ruang kerja?{" "}
              <Link to="/daftar" data-testid="tautan-daftar" className="underline text-foreground">Daftar di sini</Link>.
            </p>
          </div>
          <div className="mt-5 border-t pt-5">
            <p className="label-kecil mb-3">Akun contoh — klik untuk mengisi</p>
            <div className="grid grid-cols-2 gap-2">
              {AKUN.map(([peran, em, ps]) => (
                <button key={em} data-testid={`isi-akun-${peran.toLowerCase().replace(/\s/g, "-")}`}
                  onClick={() => { setEmail(em); setSandi(ps); }}
                  className="tombol-garis rounded px-2.5 py-2 text-xs text-left">
                  <span className="font-medium block">{peran}</span>
                  <span className="text-muted-foreground font-data text-[10px] break-all">{em}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
